export type YuzuAssetUrlMap = Record<string, string>

const YUZU_IMAGE_PATH_PREFIX = '/assets/images/'
const ALLOWED_ASSET_URL_PROTOCOLS = new Set(['http:', 'https:'])

function isYuzuImagePath(value: string): boolean {
  return value.startsWith(YUZU_IMAGE_PATH_PREFIX)
}

function isAllowedAssetUrl(value: string): boolean {
  if (/^data:image\/(png|jpeg|webp);base64,[\w+/=]+$/.test(value)) return true
  try {
    return ALLOWED_ASSET_URL_PROTOCOLS.has(new URL(value).protocol)
  } catch {
    return false
  }
}

/** Keeps only exact Yuzu image paths mapped to absolute HTTP(S) display URLs. */
export function normalizeYuzuAssetUrls(input: unknown): YuzuAssetUrlMap {
  if (!input || typeof input !== 'object' || Array.isArray(input)) return {}

  const normalized: YuzuAssetUrlMap = {}
  for (const [path, url] of Object.entries(input)) {
    if (
      isYuzuImagePath(path)
      && typeof url === 'string'
      && isAllowedAssetUrl(url)
    ) {
      normalized[path] = url
    }
  }
  return normalized
}

/** Resolves a Yuzu-relative image for display without mutating the stored source. */
export function resolveYuzuAssetUrl(
  source: string,
  assetUrls: Readonly<YuzuAssetUrlMap>,
): string {
  if (!isYuzuImagePath(source)) return source
  return assetUrls[source] ?? source
}
